var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.3396 38.5938L35.9208 21.9531L52.3396 5.3125L68.7583 21.9531L52.3396 38.5938ZM9.25 32.9688V9.45313H32.4521V32.9688H9.25ZM41.4708 65.625V42.1094H64.6729V65.625H41.4708ZM9.25 65.625V42.1094H32.4521V65.625H9.25ZM13.875 28.2813H27.8271V14.1406H13.875V28.2813ZM52.5708 32.2656L62.5146 22.1875L52.5708 12.1094L42.6271 22.1875L52.5708 32.2656ZM46.0958 60.9375H60.0479V46.7969H46.0958V60.9375ZM13.875 60.9375H27.8271V46.7969H13.875V60.9375Z",
    fill: "#00CDA7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlign);
export default __webpack_public_path__ + "static/media/align.da6da83a80ecacd3bd3a71978a1af2c9.svg";
export { ForwardRef as ReactComponent };